import { httpAdmin, httpEnrollmentClient } from '../common/httpClient';
import API_CONST from '@/constants/ApiConst';
import {
  AccountPaymentOnboardingStatus,
  CatalogSessionFilters,
  CatalogSessionList,
  CatalogSessionListRequest,
} from '@/Model/sessions/catalogTypes';
import { AxiosResponse } from 'axios';

export function retrieveCatalogSessionList(
  catalogSessionRequest: CatalogSessionListRequest
) {
  return httpEnrollmentClient({ interceptor: false }).post<CatalogSessionList>(
    `${API_CONST.SESSION_CATALOG}`,
    catalogSessionRequest
  );
}

export function retrieveCatalogSessionFilters(accountId: number) {
  return httpEnrollmentClient({ interceptor: false }).get<
    CatalogSessionFilters
  >(`${API_CONST.SESSION_CATALOG_FILTERS}?accountId=${accountId}`);
}

export function retrieveAccountPaymentOnboardingStatus(accountId: number): Promise<AxiosResponse<AccountPaymentOnboardingStatus>>  {
  return httpAdmin().get<any>(`${API_CONST.PAYMENT_ONBOARDING_STATUS}/${accountId}`);
}
